import React, { useContext, useEffect, useState } from 'react'

import './popupbitcoin.css';
import styles from './PopupBooks.module.scss';
import { useForm } from '../../hooks/useForm';
import { useAxiosPost } from '../../hooks/useSuscribir';
import { PopupContext } from '../../context/PopupContext';
import { useTranslation } from 'react-i18next';

import back_i from '../../assets/imgs/libro_bitcoin/fondo-bitcoin-left-low.png';
import back_d from '../../assets/imgs/libro_bitcoin/fondo-bitcoin-right-low.png';

const PopupBitcoin = ({ imgTemp, titleLeft, titleRigth }) => {

    const { visible, setVisible } = useContext(PopupContext)
    const [t, i18n] = useTranslation('global');
    const [isAccepted, setIsAccepted] = useState(false);

    const [formSubmitted, setFormSubmitted] = useState(false)
    const { formState, onInputChange, name, lastName, email, onResetForm } = useForm({
        names: '',
        lastName: '',
        email: ''
    });


    const notAllowedChars = ['"', '`', '=', ';', '[', ']', '{', '}', '/', '\\', '&', '<', '>', ':', '\''];



    const handleFormSubmitted = (value) => {
        setFormSubmitted(value);
    };

    const { data, isLoading, error } = useAxiosPost(
        formSubmitted ? 'https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/email/send-email-temp/'+t('forms.guid') : null,
        { fromName: name, from: email, to: email, subject:'¡Gracias por suscribirte al blog!', body:"", isBodyHtml: false},
        handleFormSubmitted);

    const onFormSubmit = (event) => {
        event.preventDefault();

        if (name.length <= 1 || lastName.length <= 1 || email.length <= 1) return;

        if (!isAccepted) {
            alert(t("forms.mustAccept")); // asegúrate de tener esta key en las traducciones
            return;
        }

        setFormSubmitted(true);
        setVisible(false);

        window.gtag('event', 'click', {
            event_category: 'Registro',
            event_label: 'Registro extracto',
            value: 1
        });

        alert(t("pop-up.gracias"));

        setTimeout(() => {
            setVisible(false)
        }, 700);

    }

    useEffect(() => {

        if (data === undefined) {
            onResetForm();
        }
    }, [data]);





    return (
        <div className={`${styles.popup} ${styles.popupBitcoin}`}>
            <div className={`${styles.popup__container}`}>
                <div className="responsive-container responsive-container-bit-ast only-desk">
                    <p className='text left'>{titleLeft}</p>
                    <img className="responsive-image" src={imgTemp} />
                </div>
                <div className="responsive-container responsive-container-bit-ast">
                    <p className='text'>{titleRigth}</p>
                    <div className={`${styles.popup__close}`}>
                        <button className='close-button' onClick={() => { setVisible(false) }}>
                        </button>
                    </div>
                    <form className={styles.form__popup}
                        onSubmit={onFormSubmit}>
                        <div className={`${styles.form__popup__group}`}>
                            <label className={styles.label__popup} >{t('forms.name')}</label>
                            <input type="text" name="name" value={name} className={`${styles.input_popup}`} onChange={onInputChange} />
                        </div>
                        <div className={`${styles.form__popup__group}`}>
                            <label className={styles.label__popup} >{t('forms.last_name')}</label>
                            <input type="text" name="lastName" value={lastName} className={`${styles.input_popup}`} onChange={onInputChange} />
                        </div>
                        <div className={`${styles.form__popup__group}`}>
                            <label className={styles.label__popup} >{t('forms.email')}</label>
                            <input type="email" name="email" value={email} className={`${styles.input_popup}`} onChange={onInputChange} />
                        </div>
                        <div className={`${styles.form__popup__group}`}>
                            <label>
                                <input className={`${styles.form__popup__group__input}`} type="checkbox" name="acept" checked={isAccepted} onChange={(e) => setIsAccepted(e.target.checked)} />  {t('forms.accept')}
                            </label>
                        </div>
                        <div className={`${styles.form__popup__group} ${styles.form__popup__group__center}`}>
                            {isLoading ? (
                                <span style={{ display: visible ? 'inline' : 'none' }}>{t('forms.sending')}...</span>
                            ) : (
                                <button className={`${styles.btn} ${styles.btn_yellow}`} onClick={handleFormSubmitted}>{t('general.suscribirse')}</button>
                            )}
                        </div>
                    </form>
                </div>
                <img class="landing_bitcoin_registro_img_i especial-bit-ast" src={back_i}></img>
                <img class="landing_bitcoin_registro_img_d especial-bit-ast" src={back_d}></img>
            </div>
        </div>
    )
}


export default PopupBitcoin;